import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
/**
 * @author xiezhixiong
 * @fileoverview 队伍信息弹窗
 */
import { defineComponent, computed } from "vue";
import closeUrl from "@/assets/img/m/homePage/jf-popup-close.png";
import useRespondTo from "@/hooks/common/respond-to";
export default defineComponent({
  name: "TeamInfoPopup",
  props: {
    // 是否可见
    visible: {
      type: Boolean,
      default: false
    },
    /**
     * 队伍信息
     * eg: {
     *    name: '队伍名称',
     *    members: [
     *      { name: '名称', career: '门派', level: '等级' },
     *      { name: '名称', career: '门派', level: '等级' },
     *    ],
     * }
     */
    teamInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  emits: ["close"],
  setup(props, {
    emit
  }) {
    const {
      device
    } = useRespondTo();
    const handleClose = () => {
      emit("close");
    };
    const isMobile = computed(() => device.value === "phone" || device.value === "pad");
    return () => {
      var _teamInfo$members;
      const {
        teamInfo
      } = props;
      return _createVNode(_resolveComponent("van-overlay"), {
        "show": props.visible,
        "onUpdate:show": $event => props.visible = $event,
        "zIndex": 99
      }, {
        default: () => [_createVNode("div", {
          "class": "team-info"
        }, [_createVNode("div", {
          "class": `team-info-content ${isMobile.value ? "team-info-m-content" : ""}`
        }, [_createVNode("div", {
          "class": `team-info-title ${isMobile.value ? "team-info-m-title" : ""}`
        }, [teamInfo.name, _createTextVNode("\u961F")]), _createVNode("div", {
          "class": `team-info-list-wrapper ${isMobile.value ? "team-info-m-list-wrapper" : ""}`
        }, [_createVNode("div", {
          "class": `team-info-list ${isMobile.value ? "team-info-m-list" : ""}`
        }, [_createVNode(_resolveComponent("van-row"), null, {
          default: () => [teamInfo === null || teamInfo === void 0 ? void 0 : (_teamInfo$members = teamInfo.members) === null || _teamInfo$members === void 0 ? void 0 : _teamInfo$members.map(item => _createVNode(_resolveComponent("van-col"), {
            "key": item.name,
            "span": !isMobile.value ? 8 : 12
          }, {
            default: () => [_createVNode("div", {
              "class": `team-info-list-item ${isMobile.value ? "team-info-m-list-item" : ""}`
            }, [_createVNode("div", null, [_createVNode("span", {
              "class": "label"
            }, [_createTextVNode("\u6210\u5458\uFF1A")]), _createVNode("span", null, [item.name])]), _createVNode("div", null, [_createVNode("span", {
              "class": "label"
            }, [_createTextVNode("\u95E8\u6D3E\uFF1A")]), _createVNode("span", null, [item.career])]), _createVNode("div", null, [_createVNode("span", {
              "class": "label"
            }, [_createTextVNode("\u7B49\u7EA7\uFF1A")]), _createVNode("span", null, [item.level])])])]
          }))]
        })])]), _createVNode("img", {
          "class": `team-info-close ${isMobile.value ? "team-info-m-close" : ""}`,
          "onClick": handleClose,
          "src": closeUrl
        }, null)])])]
      });
    };
  }
});